import hideFormFields from "../modules/hideFormFields";

document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector('.lieferantenselbstauskunft')
    if (!container) return;

    hideFormFields('lieferantenselbstauskunft');
    const error = document.querySelector('.lieferantenselbstauskunft form label + ul');
    if (error) {
        error.scrollIntoView({behavior: 'smooth'});
    }

    let page = 1;
    const form = container.querySelector('form');
    const forwardButton = form.querySelector('#lieferantenselbstauskunft_submit');
    const backButton = form.querySelector('#lieferantenselbstauskunft_back');
    const formCompliance = form.querySelector('#lieferantenselbstauskunft_compliance');
    const formComplianceLabel = formCompliance.previousElementSibling;
    const formAllgemeines = form.querySelector('#lieferantenselbstauskunft_allgemeines');
    const uploadsAllgemeines = formAllgemeines.querySelectorAll('input[type="file"]');
    const formRecht = form.querySelector('#lieferantenselbstauskunft_recht');
    const formRechtLabel = formRecht.previousElementSibling;
    const formRechtDatenschutz = formRecht.querySelector('#lieferantenselbstauskunft_recht_datenschutz');
    const uploadsRecht = formRecht.querySelector('input[type="file"]');
    const collectionHolder = form.querySelector('#lieferantenselbstauskunft_allgemeines_ansprechpartner_weitereAnsprechpartner');
    const addAnsprechpartnerButton = form.querySelector('#lieferantenselbstauskunft_allgemeines_ansprechpartner_addAnsprechpartner');
    const requiredFieldsAllgemeines = formAllgemeines.querySelectorAll('[required]');
    const requiredFieldsCompliance = formCompliance.querySelectorAll('[required]');

    const managementsystem = formRecht.querySelector('#lieferantenselbstauskunft_recht_nachhaltigkeit_zertifizierteManagementsysteme');
    const keinMangementsystem = formRecht.querySelector('#lieferantenselbstauskunft_recht_nachhaltigkeit_keineZertifizierteManagementsysteme');

    const personenbezogeneDaten = formRechtDatenschutz.querySelector('#lieferantenselbstauskunft_recht_datenschutz_personenbezogeneDaten');
    const datenschutzBeziehungInputs = formRechtDatenschutz.querySelectorAll('[name="lieferantenselbstauskunft[recht][datenschutz][datenschutzBeziehung]"]');
    const datenschutzBeziehung = formRechtDatenschutz.querySelector('#lieferantenselbstauskunft_recht_datenschutz_datenschutzBeziehung');
    const datenschutzBeziehungLabel = datenschutzBeziehung.previousElementSibling;

    const personenbezogeneDatenAuslandInputs = formRechtDatenschutz.querySelectorAll('[name="lieferantenselbstauskunft[recht][datenschutz][personenbezogenenDatenAusland]"]');
    const personenbezogeneDatenAusland = formRechtDatenschutz.querySelector('#lieferantenselbstauskunft_recht_datenschutz_personenbezogenenDatenAusland');
    const personenbezogeneDatenAuslandLabel = personenbezogeneDatenAusland.previousElementSibling;

    const drittlaenderInputs = formRechtDatenschutz.querySelectorAll('[name="lieferantenselbstauskunft[recht][datenschutz][welcheDrittlaender]"]');
    const drittlaenderLabel = formRechtDatenschutz.querySelector('[for="lieferantenselbstauskunft_recht_datenschutz_welcheDrittlaender"]');

    const grundlageInputs = formRechtDatenschutz.querySelectorAll('[name="lieferantenselbstauskunft[recht][datenschutz][personenbezogenenDatenRechtsgrundlage]"]');
    const grundlageLabel = formRechtDatenschutz.querySelector('[for="lieferantenselbstauskunft_recht_datenschutz_personenbezogenenDatenRechtsgrundlage"]');

    const backButtonContainer = form.querySelector('div:has(> #lieferantenselbstauskunft_back)')

    const errorMarkup = (field) => {
        if (field.type === 'email') {
            const label = form.querySelector(`label[for="${field.id}"]`).textContent
            return `<div class="error-message icon-cancel-circle">Bitte geben Sie bei dem Feld "${label}" eine gültige E-Mail-Adresse an.</div>`
        } else if (field.type === 'radio') {
            const label = field.parentElement.previousElementSibling.textContent
            return field.id.endsWith('0') ? `<div class="error-message icon-cancel-circle">Bitte wählen Sie eine Option für "${label}".</div>` : null
        }
        const label = form.querySelector(`label[for="${field.id}"]`).textContent
        return `<div class="error-message icon-cancel-circle">Bitte füllen Sie das Feld "${label}" aus.</div>`
    }

    const validateField = (valid, field) => {
        field.classList.remove('invalid')
        if (field.checkValidity()) return valid;
        field.classList.add('invalid')
        const markup = errorMarkup(field)
        if (markup !== null) {
            backButtonContainer.insertAdjacentHTML('beforebegin', errorMarkup(field))
        }
        return false;
    }

    const validateUploads = fields => {
        return Array.from(fields).reduce((valid, field) => {
            field.classList.remove('invalid');
            const acceptedFileTypes = field.accept.split(', ')
            const isValid = Array.from(field.files).every(file => {
                return (file.size < 5 * 1024 * 1024) && acceptedFileTypes.some(type => {
                    const [fileType, fileSubType] = file.type.split('/');
                    const [acceptedType, acceptedSubType] = type.split('/');

                    return (acceptedType === '*' || fileType === acceptedType) && (acceptedSubType === '*' || fileSubType === acceptedSubType)
                });
            });
            if (isValid) return valid;
            field.classList.add('invalid');
            const label = form.querySelector(`label[for="${field.id}"]`).textContent
            backButtonContainer.insertAdjacentHTML(
                'beforebegin',
                `<div class="error-message icon-cancel-circle">Die Dateien im Feld "${label}" dürfen maximal 5MB groß sein und müssen entweder Bilder${acceptedFileTypes.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? ', Word-Dokumente' : ''} oder PDFs sein.</div>`)
            return false;
        }, true);
    }

    const validateSection = requiredFields => {
        form.querySelectorAll('.error-message').forEach(element => element.remove())
        return Array.from(requiredFields).reduce(validateField, true);
    }

    const validateAllgemeines = () => {
        const validSection = validateSection(requiredFieldsAllgemeines);
        const validUploads = validateUploads(uploadsAllgemeines);
        return validSection && validUploads;
    }

    const validateRecht = () => {
        const requiredFieldsRecht = formRecht.querySelectorAll('[required]');
        let valid = true;
        if (!validateSection(requiredFieldsRecht)) {
            valid = false;
        }
        if (!validateUploads(uploadsRecht)) {
            valid = false;
        }
        managementsystem.classList.remove('invalid')
        if (!(keinMangementsystem.checked || managementsystem.querySelector(':checked'))) {
            managementsystem.classList.add('invalid')
            backButtonContainer.insertAdjacentHTML('beforebegin', `<div class="error-message icon-cancel-circle">Bitte wählen Sie eine Option bei "${managementsystem.previousElementSibling.textContent}".</div>`)
            valid = false
        }
        return valid;
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (page === 1) {
            if (validateAllgemeines()) {
                page = 2;
                formAllgemeines.classList.add('hidden');
                formComplianceLabel.classList.remove('hidden');
                formCompliance.classList.remove('hidden');
                backButton.classList.remove('hidden');
                formCompliance.scrollIntoView({behavior: 'smooth'});
            } else {
                alert('Bitte füllen Sie alle Pflichtfelder aus, bevor Sie fortfahren.');
            }
        } else if (page === 2) {
            if (validateSection(requiredFieldsCompliance)) {
                page = 3;
                formComplianceLabel.classList.add('hidden');
                formCompliance.classList.add('hidden');
                forwardButton.textContent = 'Absenden';
                formRechtLabel.classList.remove('hidden');
                formRecht.classList.remove('hidden');
                formRecht.scrollIntoView({behavior: 'smooth'});
            } else {
                alert('Bitte füllen Sie alle Pflichtfelder aus, bevor Sie fortfahren.');
            }
        } else if (page === 3) {
            if (validateRecht()) {
                form.submit();
            } else {
                alert('Bitte füllen Sie alle Pflichtfelder aus, bevor Sie fortfahren.');
            }
        }
    });

    backButton.addEventListener('click', () => {
        if (page === 2) {
            page = 1;
            formComplianceLabel.classList.add('hidden');
            formCompliance.classList.add('hidden');
            formAllgemeines.classList.remove('hidden');
            backButton.classList.add('hidden');
            formAllgemeines.scrollIntoView({behavior: 'smooth'});
        } else if (page === 3) {
            page = 2;
            formRechtLabel.classList.add('hidden');
            formRecht.classList.add('hidden');
            forwardButton.textContent = 'Weiter';
            formComplianceLabel.classList.remove('hidden');
            formCompliance.classList.remove('hidden');
            formCompliance.scrollIntoView({behavior: 'smooth'});
        }
    });

    addAnsprechpartnerButton.addEventListener('click', () => {
        const index = collectionHolder.childElementCount;
        const newItem = collectionHolder.dataset.prototype.replace(/__name__/g, index);
        collectionHolder.insertAdjacentHTML('beforeend', newItem);
    });

    const setRequired = (dependant, values, inputs, label) => {
        const dependantValue = dependant.querySelector(':checked')?.value;
        if (values.includes(dependantValue)) {
            inputs.forEach(el => {
                el.setAttribute('required', 'required')
            })
            if (!label.textContent.endsWith('*')) {
                label.textContent += '*';
            }
        } else {
            inputs.forEach(el => {
                el.removeAttribute('required')
            })
            if (label.textContent.endsWith('*')) {
                label.textContent = label.textContent.slice(0, -1);
            }
        }
    }

    const removeSubsequentRequired = (element) => {
        const nextElement = element.nextElementSibling;
        if (!nextElement) return;
        nextElement.querySelectorAll('input, textarea').forEach(field => {
            field.removeAttribute('required')
        })
        removeSubsequentRequired(nextElement);
    }

    formRechtDatenschutz.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement) || event.target.type !== "radio") return;
        setRequired(personenbezogeneDaten, ['Ja'], datenschutzBeziehungInputs, datenschutzBeziehungLabel);
        setRequired(datenschutzBeziehung, ['Auftragsverarbeitung'], personenbezogeneDatenAuslandInputs, personenbezogeneDatenAuslandLabel)
        setRequired(personenbezogeneDatenAusland, ['Ja'], drittlaenderInputs, drittlaenderLabel)
        setRequired(personenbezogeneDatenAusland, ['Ja'], grundlageInputs, grundlageLabel)
        if (personenbezogeneDaten.querySelector(':checked')?.value !== 'Ja') {
            removeSubsequentRequired(personenbezogeneDaten.parentElement)
            return;
        }
        const datenschutzBeziehungValue = datenschutzBeziehung.querySelector(':checked')?.value
        console.log(datenschutzBeziehungValue, datenschutzBeziehungValue !== 'Gemeinsame Verantwortung' && datenschutzBeziehungValue !== 'Auftragsverarbeitung')
        if (datenschutzBeziehungValue !== 'Gemeinsame Verantwortung' && datenschutzBeziehungValue !== 'Auftragsverarbeitung') {
            removeSubsequentRequired(datenschutzBeziehung.parentElement)
        }
    })

    form.addEventListener('change', event => {
        if (!(event.target instanceof HTMLElement)) return;
        event.target.parentElement.classList.remove('invalid')
        Array.from(event.target.parentElement.children).forEach(field => field.classList.remove('invalid'));
    })
})